import RequestGuard from 'libs/request-guard';

export default function(data) {
  this.$el = $('#course_participation');
  this.$window = $(window);
  this.windowWidth = ko.observable(this.$window.width());
  this.tabletBreakPoint = Kadenze.UIUtil.tabletBreakPoint();
  this.mobileTableViewMode = ko.observable('days');
  this.$tableMobileModal = $('#mobile_modal_parent');
  this.$dateMobileModal = $('#mobile_modal_date');
  this.$editMobileModal = $('#mobile_modal_edit_attendance');
  this.$attendance_modal = $('#attendance_modal');
  this.selectedDate = ko.observable('');

  this.attendance_modal_meta = {
    type: ko.observable(''),
    date: ko.observable().extend({defaultValue: moment().format(I18n.t('date.formats.js_default_with_zone')) }),
    index: ko.observable(-1),
    global_status: ko.observable('').extend({notify: 'always'})
  };
  
  this.attendance = ko.observable();
  this.attendance_type = ko.observable('class');
  this.selected_attendance = ko.observableArray();
  this.attendance_statuses = ['present','tardy','absent','excused'];
  this.lastChangedStatus = ko.observable('');
  this.editNoteMode = ko.observable(false);
  this.student_sort_direction = ko.observable('ASC');
  this.search_query = ko.observable();
  this.paginationOptions = ['10', '25', '50', '100'];
  this.selectedPer = ko.observable(this.paginationOptions[3]);
  this.name_mode = ko.observable('last_first');
  this.selectedPage = ko.observable(1);
  this.totalStudents = ko.observable();
  this.lastPage = ko.observable();
  this.firstPage = ko.observable();

  this.initUI = () => {
    this.attendance_modal_meta.global_status.subscribe(this.updateAllStatuses);
    this.attendance_type.subscribe(this.updateAttendanceType);

    this.$attendance_modal.on('hidden.bs.modal', () => {
      this.resetModalData();
    });
    
    if(this.windowWidth() < this.tabletBreakPoint)
      this.setMobileScrollLoadEvent();

    new RequestGuard().init();
  };

  this.sortDirectionClass = () => {
    return ko.pureComputed(() => {
      if(this.student_sort_direction() === 'ASC'){
        return 'up';
      } else if(this.student_sort_direction() === 'DESC') {
        return 'down';
      } else {
        return 'hidden';
      }
    }, this);
  };

  this.toggleNameMode = () => {
    if (this.name_mode() == 'first_last') {
      this.name_mode('last_first');
    } else {
      this.name_mode('first_last');
    }

    this.$el.click(); //Hack to close selectpicker & menus
  };

  this.toggleStudentSort = () => {
    const opp_direction = this.student_sort_direction() == 'ASC' ? 'DESC' : 'ASC';
    this.student_sort_direction(opp_direction);
  };

  this.showEditMobileModal = (attendance, name) => {
    const vm = ko.dataFor(this.$editMobileModal[0]);
    const data = {
      attendance: attendance,
      full_name: name,
      parentVM: this
    };

    vm.modalData(data);

    this.$editMobileModal.modal('show');
  };

  this.showMobileModal = (modal, set_date_context=false) => {
    if(set_date_context)
      this.selectedDate(set_date_context);

    modal.modal('show');
  };

  this.toggleMobileTableView = () => {
    this.$tableMobileModal.modal('hide');

    if (this.mobileTableViewMode() == 'days') {
      this.mobileTableViewMode('totals');
    } else {
      this.mobileTableViewMode('days');
    }
  };

  this.setMobileScrollLoadEvent = () => {
    $(window).scroll(() => {
      const scrollTop = $(this).scrollTop();
      const windowHeight = $(this).height();

      if (
        scrollTop + windowHeight == $(document).height() &&
          this.windowWidth() < this.tabletBreakPoint &&
            !this.lastPage()
      ) {
        const oldPer = parseInt(this.selectedPer());
        this.selectedPer(oldPer + 50);
      }
    });
  };

  this.userInfoTooltipParams = user => {
    return {
      template: 'templates/tooltip-userinfo',
      templateParams: {
        full_name: user.full_name(),
        username: user.slug(),
        email: user.email(),
        avatar: user.avatar(),
        profile_path: user.profile_path(),
        message_path: user.message_path()
      },
      position: 'top',
      showDelay: .7
    };
  };

  this.$window.resize(() => { this.windowWidth(this.$window.width()); });

  /*--------------------------------------------DATA BINDING FUNCTIONS------------------------------------------------*/
  this.bindData = data => {   
    const mapping = {
      create: options => {
        const subMap = {
          students: {
            create: options => {
              const vm = ko.mapping.fromJS(options.data);

              vm.switchNameMode = ko.computed(() => {
                if (this.name_mode() == 'first_last') {
                  return `${vm.first_name() } ${vm.last_name()}`;
                }
                else
                  return `${vm.last_name()}, ${vm.first_name()}`;
              });

              vm.status_map = ko.computed(() => {
                return vm.attendances().map(attendance => attendance.status());
              });

              vm.status_counts = ko.computed(() => {
                return _.countBy(vm.status_map(), status => status);
              });

              vm.attendance_grade.value.subscribeChanged((newValue, oldValue) => {
                if (newValue != oldValue)
                  this.saveAttendanceGrade(vm.attendance_grade);
              });

              vm.attendance_grade.computed_value = ko.computed({
                read: () => vm.attendance_grade.value(),

                write: value => {
                  vm.attendance_grade.overridden(true);
                  vm.attendance_grade.value(value);
                },

                owner: vm
              }).extend({ min: 0, max: 100 });

              return vm;
            }
          }
        };

        return ko.mapping.fromJS(options.data, subMap);
      }
    };

    const mapped_data = ko.mapping.fromJS(data, mapping);

    this.attendance(mapped_data);
    this.totalStudents(data['total_students']);
    this.firstPage(data['first_page']);
    this.lastPage(data['last_page']);
  };

  this.bindModalData = data => {
    const mapping = {
      create: options => {
        const vm = ko.mapping.fromJS(
          Object.assign({}, options.data, {
            date_string: ko.computed(() => {
              return Kadenze.Util.getMomentDateFromObservable(
                this.attendance_modal_meta.date
              ).utc().format(I18n.t('date.formats.js_default_with_zone'));
            }),
            attendance_type: this.attendance_type(),
          })
        );

        vm.edit_note_mode = ko.observable(!_.isEmpty(vm.notes()))

        vm.status.extend({ required: true });
        vm.status.subscribe(this.setGlobalStatus);

        return vm;
      }
    };

    const mapped_attendance = ko.mapping.fromJS(data, mapping);

    this.selected_attendance(mapped_attendance());

    this.setGlobalStatus();
  };

  this.resetModalData = () => {
    this.attendance_modal_meta.type('');
    this.attendance_modal_meta.global_status('');

    this.attendance_modal_meta.date(
      moment().format(I18n.t('date.formats.js_default_with_zone'))
    );

    this.attendance_modal_meta.index(-1);
    this.selected_attendance([]);
  };

  this.getBoxCss = (item, status) => {
    if(item.status() == status) {
      return 'selected ' + status;
    } else {
      return status;
    }
  };

  this.saveAttendance = (item, hideTooltip) => {
    Kadenze.UIUtil.makeRequest(
      Kadenze.Routes.update_all_course_attendances_path(this.course_id),
      'POST',
      { course: { attendances_attributes: [ko.mapping.toJS(item)] } },
      null,
      null,
      () => hideTooltip(), // Success
      () => item.status(this.lastChangedStatus()) // Error
    )

    this.lastChangedStatus('');
    this.selectedDate('');
    this.$editMobileModal.modal('hide');
    this.refreshAttendances(null, { type: item.attendance_type() });
  };

  this.toggleAutoCalculation = (item, event) => {
    const overridden = item.attendance_grade.overridden();
    item.attendance_grade.overridden(!overridden);
  };
  
  this.addAttendances = (item, event) => {
    const url = Kadenze.Routes.edit_all_course_attendances_path(
      this.course_id,
      {
        student_sort: this.student_sort_direction(),
        name_order: this.name_mode()
      }
    );

    const type = 'GET';

    Kadenze.UIUtil.makeRequest(url, type, null, this.$el, null,
      (data, textStatus, xhr) => { //Success
        this.attendance_modal_meta.type('add');
        this.bindModalData(data);
        this.$attendance_modal.modal('show');
        this.attendance_modal_meta.global_status('present');
      }, (xhr, textStatus, errorThrown) => { //Error
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });
  };

  this.editAttendances = selected_date => {
    const url = Kadenze.Routes.edit_all_course_attendances_path(
      this.course_id,
      {
        date: selected_date.raw(),
        student_sort: this.student_sort_direction(),
        name_order: this.name_mode()
      }
    );

    const type = 'GET';

    Kadenze.UIUtil.makeRequest(url, type, null, this.$el, null,
      (data, textStatus, xhr) => { //Success
        this.attendance_modal_meta.type('edit');

        this.attendance_modal_meta.date(
          Kadenze.Util.getMomentDateFromObservable(
            selected_date.formatted_date_string
          ).format(I18n.t('date.formats.js_default_with_zone'))
        );

        this.attendance_modal_meta.index(
          this.attendance().dates.indexOf(selected_date)
        );

        this.bindModalData(data);
        this.$dateMobileModal.modal('hide');
        this.$attendance_modal.modal('show');
      }, (xhr, textStatus, errorThrown) => { //Error
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
      });

    this.selectedDate('');
  };

  this.validateSelectedAttendance = () => {
    const client_errors = ko.validation.group(
      this.selected_attendance(),
      { deep: true }
    );

    return !client_errors().length
  };

  this.saveAttendances = (item, event) => {
    if(this.lastChangedStatus() !== '')
      this.lastChangedStatus('');

    if (!this.validateSelectedAttendance()) {
      Kadenze.UIUtil.showNotice(
        this.$attendance_modal.find('#notice_container'),
        {
          status: 'error',
          message: I18n.t('participation.save_attendances_error')
        },
        3000
      );

      return;
    }

    const success = (_data, _textStatus, _xhr) => {
      this.refreshAttendances(null, { type: this.selected_attendance().[0].attendance_type() });
      this.$attendance_modal.modal('hide');
      this.resetModalData();
    }

    const error = (xhr, _textStatus, _errorThrown) => {
      Kadenze.UIUtil.showNotice(
        this.$attendance_modal.find('#notice_container'),
        xhr.responseJSON,
        3000
      );
    }    
    Kadenze.UIUtil.makeRequest(
      Kadenze.Routes.update_all_course_attendances_path(this.course_id),
      'POST',
      {
        course: {
          attendances_attributes: ko.mapping.toJS(
            this.selected_attendance(),
            { ignore: ['date'] }
          )
        }
      },
      this.$attendance_modal,
      null,
      success,
      error
    )
  };

  this.validateAttendanceGrade = grade => {
    const client_errors = ko.validation.group(grade);
    return client_errors().length == 0;
  };

  this.saveAttendanceGrade = grade => {
    if (!this.validateAttendanceGrade(grade))
      return;    
    Kadenze.UIUtil.makeRequest(
      Kadenze.Routes.update_all_course_attendances_path(this.course_id),
      'POST',
      {
        course: {
          attendance_grades_attributes: [ko.mapping.toJS(grade)]
        }
      }
    )
  };

  this.deleteAttendances = selected_date => {
    const attendance_type = $('#attendance_type_field').val();
    const prompt = I18n.t('participation.delete_attendance_prompt') +
      selected_date.time() + ' on ' + selected_date.month_day() + '?';

    const url = Kadenze.Routes.destroy_all_course_attendances_path(
      this.course_id,
      { date: selected_date.raw(),
        type: this.attendance_type()
      }
    );

    this.$dateMobileModal.modal('hide');

    Kadenze.UIUtil.confirmAction(prompt, () => {
      Kadenze.UIUtil.makeRequest(url, 'DELETE', null, this.$el, null,
        //Success
        (data, textStatus, xhr) => {
          this.attendance_modal_meta.type('delete');

          this.attendance_modal_meta.index(
            this.attendance().dates.indexOf(selected_date)
          );

          this.refreshAttendances(null, {type: attendance_type});
          this.resetModalData();
        },

        //Error
        (xhr, textStatus, errorThrown) => {
          Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000);
        });
    });
    this.selectedDate('');
  };

  this.refreshAttendances = (url, params) => {
    const reqUrl = url || Kadenze.Routes.course_attendances_path(this.course_id, params);

    Kadenze.UIUtil.makeRequest(reqUrl, 'GET', null, this.$el, null,
      // Success
      (data, textStatus, xhr) => this.bindData(data),
      // Error
      (xhr, textStatus, errorThrown) => Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 3000)
    );
  };

  this.cancelUpdateStatus = (item, hideTooltip) => {
    hideTooltip();

    if (this.lastChangedStatus() !== '') {
      item.status(this.lastChangedStatus());
      this.lastChangedStatus('');
    }

    this.editNoteMode(false);
  };

  this.updateStatus = (status, item) => {
    this.lastChangedStatus(item.status());
    item.status(status);
    this.editNoteMode(false);
  };

  this.updateAllStatuses = () => {
    if (this.attendance_modal_meta.global_status() !== '') {
      this.selected_attendance().forEach(
        a => a.status(this.attendance_modal_meta.global_status())
      );
    }
  };

  this.updateAttendanceType = () => {
    if (this.attendance_type() !== '') {
      this.selected_attendance().forEach(
        a => a.attendance_type(this.attendance_type())
      );
    }
  };

  this.setGlobalStatus = () => {
    const statuses = this.selected_attendance().map(attendance => attendance.status());
    const distinct_statuses = _.without(ko.utils.arrayGetDistinctValues(statuses), '', null);

    if (distinct_statuses.length === 1) {
      this.attendance_modal_meta.global_status(distinct_statuses[0]);
    } else {
      this.attendance_modal_meta.global_status('');
    }
  };

  this.paginationChanged = (goToFirstPage = false) => {
    Kadenze.UIUtil.showLoadingIndicator(this.$el);

    if (goToFirstPage)
      this.selectedPage(1);

    const params = {
      'page': this.selectedPage(),
      'per': this.selectedPer()
    };

    this.refreshAttendances(null, params);
  };

  this.paginationText = () => {
    return ko.pureComputed(() => {
      let min, max;

      if (this.selectedPage() == 1) {
        min = 1;
        max = this.selectedPer();
      } else {
        min = this.selectedPer() * (this.selectedPage() - 1);
        max = parseInt(min) + parseInt(this.selectedPer());
      }

      if (max > this.totalStudents()) {
        return `${min}-${this.totalStudents()} ${I18n.t('dict.of')} ${this.totalStudents()}`;
      } else {
        return `${min}-${max} ${I18n.t('dict.of')} ${this.totalStudents()}`;
      }
    }, this);
  };

  this.nextPage = () => {
    if (!this.lastPage())
      this.selectedPage(this.selectedPage() + 1);
  };

  this.previousPage = () => {
    if (!this.firstPage())
      this.selectedPage(this.selectedPage() - 1);
  };

  this.filterChanged = () => {
    this.refreshAttendances(null, { search: this.search_query() });
  };

  this.sortStudents = (name_mode, sort_direction) => {
    const students = this.attendance().students()
    let sorted = null;

    if (name_mode === 'first_last') {
      sorted = _.sortBy(students, s => s.first_name().toLowerCase())
    } else {
      sorted = _.sortBy(students, s => s.last_name().toLowerCase())
    }

    sorted = sort_direction === 'ASC' ?
      sorted :
      sorted.reverse();

    this.attendance().students(sorted);
  };

  this.selectedPer.subscribe(() => {
    if(!this.firstPage()){
      this.paginationChanged(true);
    } else {
      this.paginationChanged();
    }
  });

  this.selectedPage.subscribe(
    () => this.paginationChanged()
  )

  this.name_mode.subscribe(
    value => this.sortStudents(value, this.student_sort_direction())
  )

  this.student_sort_direction.subscribe(
    value => this.sortStudents(this.name_mode(), value)
  )

  this.exportAsCSV = () => {
    window.location.href = Kadenze.Routes.course_participation_path(
      this.course_id,
      { format: 'csv' }
    );
  };

  let $id = document.getElementById("external_id");
  let $rc = $(".attendance__table-flex-group").find('.attendance__table_content')
  let $dc = $("#date_columns")
  $id.style.display = "none";
  $rc.addClass('attendance-external-id-table-content');
  $dc.addClass('attendance-table-column-date-range');

  this.toggleExternalID = () => {
    if ($id.style.display === 'none') {
      $id.style.display = "block";
      $rc.removeClass('attendance-external-id-table-content');
      $dc.removeClass('attendance-table-column-date-range');
    }
    else {
      $id.style.display = "none";
      $rc.addClass('attendance-external-id-table-content');
      $dc.addClass('attendance-table-column-date-range');
    }
  };

  (() => {
    this.course_id = $('#course_id').val();
    this.bindData(data);
  })();
}
